<button
  class="sn-toggle"
  type="button"
  (click)="toggleCollapsed()"
  [attr.aria-label]="isCollapsed() ? ('shell.sidebar.expand' | transloco) : ('shell.sidebar.collapse' | transloco)"
  >
  <i class="ft-chevrons-left rtl-flip" [class.sn-toggle--flipped]="isCollapsed()"></i>
</button>

<a routerLink="/" class="sn-logo-link" [attr.aria-label]="'shell.sidebar.goToDashboard' | transloco">
  <span class="sn-logo" [class.sn-logo--wide]="!courseBrandName()">
    <img class="sn-logo__icon" [src]="brandLogo()" [attr.alt]="courseBrandName() ?? ('common.brandName' | transloco)" />
  </span>
  <span class="sn-nav-label sn-logo-text">{{ courseBrandName() ?? ('common.brandName' | transloco) }}</span>
</a>

<nav class="sn-nav" [attr.aria-label]="'shell.sidebar.mainNav' | transloco">
  @for (item of courseMenuItemRoutes(); track item.path) {
    <a
      [routerLink]="item.path"
      routerLinkActive="active"
      class="sn-nav-icon"
      [ngbTooltip]="item.titleKey ? (item.titleKey | transloco) : item.title"
      #t="ngbTooltip"
      placement="end"
      container="body"
      tooltipClass="sn-tooltip-blue"
      [disableTooltip]="isExpanded() || isWindowBlurred()"
      [attr.aria-label]="item.titleKey ? (item.titleKey | transloco) : item.title"
      [attr.data-cy]="'sidebar-nav-' + item.title"
      (click)="t.close(); closeOverlay()"
      >
      <i [class]="item.icon"></i>
      <span class="sn-nav-label">{{ item.titleKey ? (item.titleKey | transloco) : item.title }}</span>
    </a>
  }
</nav>

<div class="sn-bottom">
  @if (hasAssistant()) {
    <button
      type="button"
      class="sn-assistant-btn"
      (click)="assistantTooltip.close(); toggleAssistant()"
      [ngbTooltip]="'shell.sidebar.assistant' | transloco"
      #assistantTooltip="ngbTooltip"
      placement="end"
      container="body"
      tooltipClass="sn-tooltip-blue"
      [disableTooltip]="isExpanded() || isWindowBlurred()"
      [attr.aria-label]="'shell.sidebar.assistant' | transloco"
      data-cy="sidebar-assistant-btn"
      >
      <svg viewBox="0 0 24 24" fill="none" class="sn-assistant-icon" aria-hidden="true">
        <rect x="2" y="4" width="20" height="14" rx="3" fill="white"/>
        <path d="M8 22 L12 18 H20 C21.66 18 23 16.66 23 15 V7 C23 5.34 21.66 4 20 4 H4 C2.34 4 1 5.34 1 7 V15 C1 16.66 2.34 18 4 18 H8 V22Z" fill="white" opacity="0"/>
        <circle cx="8" cy="11" r="1.2" fill="currentColor"/>
        <circle cx="12" cy="11" r="1.2" fill="currentColor"/>
        <circle cx="16" cy="11" r="1.2" fill="currentColor"/>
      </svg>
      <span class="sn-nav-label">{{ "shell.sidebar.assistant" | transloco }}</span>
    </button>
  }

  <div class="sn-notifications-wrap" (click)="toggleNotifications()">
    <app-my-notifications
      #notificationsComp
      [notifications]="myNotificationsList$"
      [darkThemeSupport]="true"
      (dispatchEvent)="dispatchEvent()"
      (panelOpenChange)="notifTooltip.close(); onNotificationOpen($event)"
      [ngbTooltip]="'shell.sidebar.notifications' | transloco"
      #notifTooltip="ngbTooltip"
      placement="end"
      container="body"
      tooltipClass="sn-tooltip-blue"
      [disableTooltip]="isNotificationOpen() || isExpanded() || isWindowBlurred()"
      (click)="$event.stopPropagation(); notifTooltip.close()"
      />
    <span class="sn-nav-label">{{ "shell.sidebar.notifications" | transloco }}</span>
  </div>

  <button
    type="button"
    class="sn-nav-icon"
    (click)="goToProfileEdit(); closeOverlay()"
    [ngbTooltip]="'common.profile' | transloco"
    placement="end"
    container="body"
    tooltipClass="sn-tooltip-blue"
    [disableTooltip]="isExpanded() || isWindowBlurred()"
    [attr.aria-label]="'common.profile' | transloco"
    data-cy="sidebar-profile-link"
    >
    <i class="ft-user"></i>
    <span class="sn-nav-label">{{ "common.profile" | transloco }}</span>
  </button>

  <button
    class="sn-theme-toggle"
    [attr.aria-label]="
      isDarkMode() ? ('shell.sidebar.switchToLight' | transloco) : ('shell.sidebar.switchToDark' | transloco)
    "
    (click)="themeTooltip.close(); toggleDarkMode()"
    [ngbTooltip]="isDarkMode() ? ('shell.sidebar.lightMode' | transloco) : ('shell.sidebar.darkMode' | transloco)"
    #themeTooltip="ngbTooltip"
    placement="end"
    container="body"
    tooltipClass="sn-tooltip-blue"
    [disableTooltip]="isExpanded() || isWindowBlurred()"
    >
    @if (isDarkMode()) {
      <i class="ft-sun"></i>
    }
    @if (!isDarkMode()) {
      <i class="ft-moon"></i>
    }
    <span class="sn-nav-label">{{ isDarkMode() ? ("shell.sidebar.light" | transloco) : ("shell.sidebar.dark" | transloco) }}</span>
  </button>

  <button
    class="sn-nav-icon"
    type="button"
    (click)="goToLogoutPage(); closeOverlay()"
    [ngbTooltip]="'common.logout' | transloco"
    placement="end"
    container="body"
    tooltipClass="sn-tooltip-blue"
    [disableTooltip]="isExpanded() || isWindowBlurred()"
    [attr.aria-label]="'common.logout' | transloco"
    data-cy="sidebar-logout-btn"
    >
    <i class="ft-power"></i>
    <span class="sn-nav-label">{{ "common.logout" | transloco }}</span>
  </button>
</div>
